var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-main-title"},[(_vm.$route.meta.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$route.meta.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }